// Simple notification utilities - delegate to dialog modals
// This keeps a stable API while allowing dialog implementation to change
import { showSuccess as dialogShowSuccess, showError as dialogShowError, showConfirm as dialogShowConfirm, showToast as dialogShowToast } from "./dialog";

export const showSuccess = (message, titleOrCallback) => {
  return dialogShowSuccess(message, titleOrCallback);
};

export const showToast = (message) => {
  return dialogShowToast(message);
};

export const showError = (message, titleOrCallback) => {
  return dialogShowError(message, titleOrCallback);
};

export const showConfirm = (message, title) => {
  return dialogShowConfirm(message, title);
};
